import { useState, useEffect, useRef } from 'react';
import { HiChevronDown } from 'react-icons/hi';
import { useCurrency } from '../context/CurrencyContext';

const currencies = [
  { code: 'NGN', label: 'NGN', symbol: '₦' },
  { code: 'USD', label: 'USD', symbol: '$' },
  { code: 'EUR', label: 'EUR', symbol: '€' },   // was '£'
  { code: 'GBP', label: 'GBP', symbol: '£' },   // was '₤'
];

export default function CurrencyWidget() {
  const { currency, changeCurrency } = useCurrency();
  const [open, setOpen] = useState(false);
  const widgetRef = useRef(null);

  const selectedCurrency = currencies.find(c => c.code === currency) || currencies[0];

  useEffect(() => {
    const handleClick = (e) => {
      if (widgetRef.current && !widgetRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);

  return (
    <div ref={widgetRef} className="fixed bottom-5 right-5 z-30">
      {open && (
        <div className="mb-1.5 bg-white/90 backdrop-blur-md border border-gray-200/60 rounded-xl shadow-lg overflow-hidden animate-fade-in-up">
          {currencies.map(c => (
            <button
              key={c.code}
              onClick={() => { changeCurrency(c.code); setOpen(false); }}
              className={`w-full flex items-center gap-2 px-3 py-2 text-xs font-medium transition ${
                currency === c.code ? 'bg-gray-100 text-black' : 'text-gray-600 hover:bg-gray-50'
              }`}
            >
              <span className="text-base leading-none">{c.symbol}</span>
              <span>{c.label}</span>
            </button>
          ))}
        </div>
      )}

      <button
        onClick={() => setOpen(!open)}
        className="flex items-center gap-1.5 bg-white/70 backdrop-blur-md border border-gray-200/50 rounded-full px-3 py-1.5 text-xs font-semibold shadow hover:shadow-md transition"
      >
        <span className="text-base leading-none">{selectedCurrency.symbol}</span>
        <span>{selectedCurrency.code}</span>
        <HiChevronDown size={12} className={`transition-transform ${open ? 'rotate-180' : ''}`} />
      </button>
    </div>
  );
}